import { RichTextBlock } from 'prismic-reactjs';
import clsx from 'classnames';
import Icon from './Icon';

interface BulletListProps {
  bullets: RichTextBlock[];
  className?: string;
}

interface ParsedBullet {
  icon?: string;
  text: string;
}

const BulletList = ({ bullets, className }: BulletListProps) => {
  const parseBulletText = (text: string): ParsedBullet => {
    const regex = /\{\{(.*?)\}\}/;
    const match = regex.exec(text);
    return {
      icon: match?.[1],
      text: text.replace(regex, '').trim(),
    };
  };

  const getIconClassName = (icon: string): string => {
    const baseClasses = 'h-4 w-4 flex-shrink-0';
    const colorClass = icon === 'cross' ? 'text-[#757575]' : 'text-[#62B571]';
    return clsx(baseClasses, colorClass);
  };

  const getTextClassName = (icon: string): string => {
    const baseClasses = 'text-base font-normal leading-relaxed';
    const colorClass = icon === 'cross' ? 'text-[#757575]' : 'text-white';
    return clsx(baseClasses, colorClass);
  };

  if (!bullets?.length) return null;

  return (
    <ul className={clsx('pt-4 font-archivo', className)}>
      {bullets.map((block) => {
        const { icon, text } = parseBulletText(block.text ?? '');
        if (!text) return null;

        return (
          <li key={`bullet-${icon}`} className="flex items-center gap-4 mt-4">
            {icon && (
              <Icon
                icon={icon}
                className={getIconClassName(icon)}
                aria-hidden="true"
              />
            )}
            <span className={getTextClassName(icon ?? '')}>
              {text}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default BulletList;
